/**
 * Amorf SMS Onay — Sepet ödeme kapısı
 *
 * 1. /cart sayfasında amorf item varsa checkout butonu kilitlenir.
 * 2. Kullanıcı SMS Onayı verir: Ad + Phone → kod gönder → doğrula.
 * 3. Doğrulanınca kişiye özel onay ekranı açılır, sonra /checkout'a yönlendirir.
 *
 * Backend: https://dolcevita-massimo.ngrok.io/amorf-sms-{send|verify|status}
 */
(function() {
  'use strict';

  var API_BASE = 'https://dolcevita-massimo.ngrok.io';
  var ADDED_SELECTORS_CHECKOUT = [
    '[name="checkout"]',
    'button[name="checkout"]',
    '.hdt-btn-checkout',
    '.cart__checkout-button',
    '[data-checkout-btn]'
  ];

  // Sadece /cart sayfasında çalış
  if (!window.location.pathname.match(/^\/cart/)) return;

  // State
  var cartState = null;
  var cartToken = null;
  var amorfItems = [];
  var verifiedData = null; // verify sonrası dönen ad/soyad/talepNo

  // ═══ CART ANALYZE ═══
  async function loadCart() {
    try {
      var r = await fetch('/cart.js', { credentials: 'same-origin' });
      var j = await r.json();
      cartState = j;
      cartToken = j.token;
      amorfItems = (j.items || []).filter(function(it) {
        // SADECE amorf. Oval/daire 1 Agu 2026'da cikarildi: bu sekillerde SMS onayi istenmiyor.
        var p = it.properties || {};
        var st = (p._shapeType || p['Hali Sekli'] || p['Halı Şekli'] || '').toString().toLowerCase();
        return st === 'amorf';
      });
      // Massimo özel ölçü item'larının ürün sayfası link'lerine ?previewId enjekte et
      // → kullanıcı sepetten ürüne tıklarsa o item'ın spesifik state'i (şekil/preset/tasarım) restore olur
      try { enhanceMassimoCartLinks(j.items || []); } catch (e) {}
      return amorfItems.length > 0;
    } catch (e) {
      console.warn('[AmorfSMS] cart load error:', e);
      return false;
    }
  }

  // ═══ MASSIMO CART LINK ENHANCER ═══
  // Sepet sayfasında her Massimo özel ölçü item'ının ürün link'ine ?previewId=<_previewId>
  // ekler. Tıklayan kullanıcı ürün sayfasında o item'ın spesifik şekil/preset/tasarım/kartela
  // ayarlarını restore eder (localStorage.massimo_full_snapshot_<id> snapshot'tan).
  function enhanceMassimoCartLinks(cartItems) {
    var massimoMap = {};
    cartItems.forEach(function(it) {
      var p = it.properties || {};
      if (p._massimoOzelOlcu === '1' && p._previewId) {
        // Cart item URL kalıbı: /products/<handle>?variant=<id> veya /products/<handle>
        var u = String(it.url || '').split('?')[0];
        if (u) massimoMap[u] = p._previewId;
      }
    });
    if (!Object.keys(massimoMap).length) return;
    // Sayfa içindeki tüm ürün link'lerini gez
    var links = document.querySelectorAll('a[href*="/products/"]');
    links.forEach(function(a) {
      var href = a.getAttribute('href') || '';
      // /products/<handle> kısmını çıkar
      var pathMatch = href.match(/^(\/products\/[^?#]+)/);
      if (!pathMatch) return;
      var basePath = pathMatch[1];
      var pid = massimoMap[basePath];
      if (!pid) return;
      // Zaten previewId varsa atla
      if (href.indexOf('previewId=') !== -1) return;
      var sep = href.indexOf('?') === -1 ? '?' : '&';
      a.setAttribute('href', href + sep + 'previewId=' + encodeURIComponent(pid));
    });
  }

  // Cart sayfası DOM güncellemelerinde de enhance et (quantity değişimi, item ekleme/silme)
  var _enhanceObserver = null;
  function startCartLinkObserver() {
    if (_enhanceObserver) return;
    _enhanceObserver = new MutationObserver(function() {
      // Debounce
      if (_enhanceObserver._t) clearTimeout(_enhanceObserver._t);
      _enhanceObserver._t = setTimeout(function() {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(j) { enhanceMassimoCartLinks(j.items || []); })
          .catch(function() {});
      }, 400);
    });
    _enhanceObserver.observe(document.body, { childList: true, subtree: true });
  }
  startCartLinkObserver();

  // ═══ BACKEND API ═══
  async function apiSend(ad, soyad, tel) {
    var r = await fetch(API_BASE + '/amorf-sms-send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ad: ad, soyad: soyad, tel: tel, cartToken: cartToken })
    });
    return r.json();
  }
  async function apiVerify(tel, code) {
    var amorfs = collectAllAmorfs();
    var r = await fetch(API_BASE + '/amorf-sms-verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tel: tel, cartToken: cartToken, code: code, amorfs: amorfs })
    });
    return r.json();
  }
  async function apiStatus() {
    try {
      var ids = amorfItems
        .map(function(it) { return it.properties && it.properties._previewId; })
        .filter(Boolean);
      if (!ids.length) return { ok: true, verified: false };
      var r = await fetch(API_BASE + '/amorf-sms-status?previewIds=' + encodeURIComponent(ids.join(',')));
      return r.json();
    } catch { return { ok: false }; }
  }

  // Tek amorf item → backend'e gönderilecek obje
  function buildAmorfPayload(it) {
    var props = it.properties || {};
    var cfg = null;
    try {
      var raw = (props._previewId && localStorage.getItem('ozel_olcu_amorf_config_' + props._previewId)) ||
                localStorage.getItem('ozel_olcu_amorf_config');
      if (raw) cfg = JSON.parse(raw);
    } catch {}

    // ÖNCE cart property _radii (add-to-cart sırasında baked), SONRA localStorage cfg
    var radii = null;
    if (props._radii) {
      try { radii = JSON.parse(props._radii); } catch {}
    }
    if (!radii && cfg && cfg.radii) radii = cfg.radii;
    var widthCm = (cfg && cfg.widthCm) ||
                  parseInt(props['Genişlik'] || props['Genislik'] || props._width) ||
                  (props._size && parseInt(props._size.split('x')[0])) || 100;
    var lengthCm = (cfg && cfg.lengthCm) ||
                   parseInt(props['Uzunluk'] || props._length) ||
                   (props._size && parseInt(props._size.split('x')[1])) || 100;
    var edgeType = (cfg && cfg.edgeType) ||
                   (props._edgeType || props['Kenar Tipi'] || 'overlok').toString().toLowerCase();

    // Preview image (canvas snapshot) — Tasarımı Kaydet'in PDF üretimi için gerekli (base64)
    // localStorage'da `ozel_olcu_preview_<previewId>` anahtarında saklı
    var previewBase64 = null;
    try {
      if (props._previewId) {
        previewBase64 = localStorage.getItem('ozel_olcu_preview_' + props._previewId) || null;
      }
    } catch {}

    // Massimo tam snapshot (Tasarımı Kaydet'in `buildSaveSnapshot` çıktısı) — PDF 1:1 üretim için
    // outputGeometry, previewImgCropped, previewCropPx, designRegions gibi alanlar burada
    var massimoFullSnapshot = null;
    try {
      if (props._previewId) {
        var rawFull = localStorage.getItem('massimo_full_snapshot_' + props._previewId);
        if (rawFull) massimoFullSnapshot = JSON.parse(rawFull);
      }
    } catch {}

    return {
      previewId: props._previewId || ('it-' + it.id),
      radii: radii || new Array(60).fill(0.96),
      widthCm: widthCm,
      lengthCm: lengthCm,
      edgeType: edgeType,
      kumas: props['Biye Rengi'] || props['Bordür Kumaşı'] || props._kumas || null,
      previewBase64: previewBase64,
      cfg: cfg,
      massimoFullSnapshot: massimoFullSnapshot,
      siparis: {
        title: it.title,
        price: it.final_line_price,
        quantity: it.quantity,
        properties: props
      }
    };
  }

  // Sepetteki tüm amorf itemları → array (her biri için ayrı doğrulama)
  function collectAllAmorfs() {
    return amorfItems.map(buildAmorfPayload);
  }

  // Backward-compat: tekil amorf (step 3 modal render için)
  function collectAmorfData() {
    return amorfItems.length ? buildAmorfPayload(amorfItems[0]) : null;
  }

  // ═══ MODAL UI ═══
  var modalEl = null;
  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'amorf-sms-modal-overlay';
    modalEl.innerHTML = '<div class="amorf-sms-modal"><div class="amorf-sms-modal__header">' +
      '<h3 class="amorf-sms-modal__title">Özel Üretim Onayı</h3>' +
      '<button type="button" class="amorf-sms-modal__close" aria-label="Kapat">×</button>' +
      '</div><div class="amorf-sms-modal__body"></div></div>';
    document.body.appendChild(modalEl);
    modalEl.querySelector('.amorf-sms-modal__close').addEventListener('click', closeModal);
    modalEl.addEventListener('click', function(e) { if (e.target === modalEl) closeModal(); });
    return modalEl;
  }
  function openModal() { ensureModal().classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { if (modalEl) modalEl.classList.remove('open'); document.body.style.overflow = ''; }
  function setBody(html) {
    ensureModal();
    modalEl.querySelector('.amorf-sms-modal__body').innerHTML = html;
  }
  function setTitle(t) {
    ensureModal();
    modalEl.querySelector('.amorf-sms-modal__title').textContent = t;
  }

  // ═══ STEP 1 — AD + PHONE ═══
  function renderStep1() {
    setTitle('SMS ile Kimlik Doğrulama');
    setBody(
      '<div class="amorf-sms-modal__info">Kişiye özel üretim siparişiniz için cep telefonunuza onay kodu göndereceğiz.</div>' +
      '<div class="amorf-sms-modal__row">' +
        '<label class="amorf-sms-modal__label">Ad Soyad <span style="color:#dc2626">*</span></label>' +
        '<input type="text" class="amorf-sms-modal__input" id="amorf-sms-ad" autocomplete="name" placeholder="Örn. Ali Şanslı">' +
      '</div>' +
      '<div class="amorf-sms-modal__row">' +
        '<label class="amorf-sms-modal__label">Cep Telefonu <span style="color:#dc2626">*</span></label>' +
        '<input type="tel" class="amorf-sms-modal__input" id="amorf-sms-tel" autocomplete="tel" placeholder="05XX XXX XX XX" maxlength="15">' +
      '</div>' +
      '<div class="amorf-sms-modal__error" id="amorf-sms-err"></div>' +
      '<button type="button" class="amorf-sms-modal__btn" id="amorf-sms-send-btn">Kodu SMS ile Gönder</button>'
    );
    var btn = document.getElementById('amorf-sms-send-btn');
    btn.addEventListener('click', async function() {
      var fullName = (document.getElementById('amorf-sms-ad').value || '').trim();
      var tel = (document.getElementById('amorf-sms-tel').value || '').trim();
      var err = document.getElementById('amorf-sms-err');
      err.classList.remove('show');
      if (!fullName || fullName.split(' ').length < 2) {
        err.textContent = 'Lütfen ad ve soyadınızı tam yazın.';
        err.classList.add('show'); return;
      }
      var digits = tel.replace(/\D/g, '');
      if (digits.length < 10) {
        err.textContent = 'Geçerli bir cep telefonu numarası girin.';
        err.classList.add('show'); return;
      }
      var parts = fullName.split(/\s+/);
      var ad = parts.slice(0, -1).join(' ');
      var soyad = parts[parts.length - 1];
      btn.disabled = true; btn.textContent = 'Gönderiliyor...';
      try {
        var res = await apiSend(ad, soyad, tel);
        if (!res.ok) {
          err.textContent = res.error || 'SMS gönderilemedi.';
          err.classList.add('show');
          btn.disabled = false; btn.textContent = 'Kodu SMS ile Gönder';
          return;
        }
        renderStep2(ad, soyad, tel);
      } catch (e) {
        err.textContent = 'Bağlantı hatası: ' + e.message;
        err.classList.add('show');
        btn.disabled = false; btn.textContent = 'Kodu SMS ile Gönder';
      }
    });
  }

  // ═══ STEP 2 — KOD GİRİŞİ ═══
  function renderStep2(ad, soyad, tel) {
    setTitle('SMS Kodu');
    setBody(
      '<div class="amorf-sms-modal__info"><b>' + tel + '</b> numarasına 6 haneli onay kodu gönderildi.</div>' +
      '<div class="amorf-sms-modal__row">' +
        '<label class="amorf-sms-modal__label">Doğrulama Kodu</label>' +
        '<input type="text" class="amorf-sms-modal__input code" id="amorf-sms-code" maxlength="6" inputmode="numeric" pattern="[0-9]*" placeholder="------">' +
      '</div>' +
      '<div class="amorf-sms-modal__error" id="amorf-sms-err"></div>' +
      '<div class="amorf-sms-modal__timer" id="amorf-sms-timer">Kod 5:00 içinde geçersiz olur</div>' +
      '<button type="button" class="amorf-sms-modal__btn" id="amorf-sms-verify-btn">Doğrula</button>' +
      '<button type="button" class="amorf-sms-modal__btn amorf-sms-modal__btn--ghost" id="amorf-sms-back">Geri Dön</button>'
    );
    // Timer
    var remaining = 300;
    var timerEl = document.getElementById('amorf-sms-timer');
    var interval = setInterval(function() {
      remaining--;
      var m = Math.floor(remaining / 60), s = remaining % 60;
      timerEl.textContent = 'Kod ' + m + ':' + (s < 10 ? '0' + s : s) + ' içinde geçersiz olur';
      if (remaining <= 0) {
        clearInterval(interval);
        timerEl.textContent = 'Kod süresi doldu, lütfen yeni kod isteyin.';
      }
    }, 1000);
    document.getElementById('amorf-sms-back').addEventListener('click', function() { clearInterval(interval); renderStep1(); });
    document.getElementById('amorf-sms-verify-btn').addEventListener('click', async function() {
      var code = (document.getElementById('amorf-sms-code').value || '').trim();
      var err = document.getElementById('amorf-sms-err');
      err.classList.remove('show');
      if (code.length !== 6) {
        err.textContent = '6 haneli kodu girin.';
        err.classList.add('show'); return;
      }
      var btn = this;
      btn.disabled = true; btn.textContent = 'Doğrulanıyor...';
      try {
        var res = await apiVerify(tel, code);
        if (!res.ok) {
          err.textContent = res.error || 'Kod doğrulanamadı.';
          err.classList.add('show');
          btn.disabled = false; btn.textContent = 'Doğrula';
          return;
        }
        clearInterval(interval);
        verifiedData = res;
        // Gate banner'ı güncelle
        updateGateUI(true);
        renderStep3(res);
      } catch (e) {
        err.textContent = 'Bağlantı hatası: ' + e.message;
        err.classList.add('show');
        btn.disabled = false; btn.textContent = 'Doğrula';
      }
    });
  }

  // ═══ STEP 3 — KİŞİSELLEŞTİRİLMİŞ ONAY ═══
  function renderStep3(verifyRes) {
    setTitle('Sipariş Detaylarınız');
    var amorf = collectAmorfData();
    var it = amorfItems[0];
    var props = it.properties || {};

    // TR biçim: 12.345,67 TL
    function fmtTL(cents) {
      return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    }
    var totalPrice = fmtTL(cartState.total_price);
    var kazanc = cartState.total_discount ? fmtTL(cartState.total_discount) : null;
    var taksit6 = fmtTL(Math.round(cartState.total_price / 6));
    var taksit3 = fmtTL(Math.round(cartState.total_price / 3));

    var previewUrl = null;
    // SADECE bu ürünün kendi _previewId'sinden preview — generic fallback YOK
    // (farklı amorf'ların karışmaması için)
    if (props._previewId) {
      try { previewUrl = localStorage.getItem('ozel_olcu_preview_' + props._previewId); } catch {}
    }

    var fabricUrl = null;
    try {
      // Fabric URL önce cart property'den (yedek), sonra SADECE bu previewId'nin config'inden
      if (props._fabricSwatchUrl) {
        fabricUrl = props._fabricSwatchUrl;
      } else if (props._previewId) {
        var raw = localStorage.getItem('ozel_olcu_amorf_config_' + props._previewId);
        if (raw) { var cfg = JSON.parse(raw); if (cfg && cfg.fabricUrl) fabricUrl = cfg.fabricUrl; }
      }
    } catch {}

    var siparisDim = amorf.widthCm + '×' + amorf.lengthCm;
    var prodW = Math.round(amorf.widthCm * 0.96);
    var prodH = Math.round(amorf.lengthCm * 0.96);
    var edgeLabel = amorf.edgeType === 'bordur' ? 'Bordür' :
                    amorf.edgeType === 'biye'   ? 'Biye' : 'Overlok';
    var kumasLabel = amorf.kumas ? amorf.kumas : (fabricUrl ? 'Seçildi' : 'Belirtilmemiş');

    var fabricBlock = fabricUrl ? (
      '<div class="amorf-sms-confirm__fabric">' +
        '<div class="amorf-sms-confirm__fabric-img-wrap"><img src="' + fabricUrl + '" alt="Kumaş"></div>' +
        '<div class="amorf-sms-confirm__fabric-info">' +
          '<div class="amorf-sms-confirm__fabric-label">Seçilen Kumaş · ' + edgeLabel + '</div>' +
          '<div class="amorf-sms-confirm__fabric-code">' + kumasLabel + '</div>' +
          '<div class="amorf-sms-confirm__fabric-note">Ekran / cihaz ayarından kaynaklı renk tonu farklılıkları olabilir.</div>' +
        '</div>' +
      '</div>'
    ) : '';

    setBody(
      '<div class="amorf-sms-confirm__greeting">Sayın ' + verifyRes.ad + ',</div>' +
      '<div class="amorf-sms-confirm__lead">' +
        '<b>SMS onayınız alındı.</b> Amorf siparişinize devam edebilir, ödeme sürecine geçebilirsiniz.' +
      '</div>' +

      (previewUrl ? (
        '<div class="amorf-sms-confirm__hero">' +
          '<img src="' + previewUrl + '" alt="Halı şekliniz" class="amorf-sms-confirm__hero-img">' +
          '<div class="amorf-sms-confirm__hero-dims">' +
            '<span>Sipariş: <b>' + siparisDim + ' cm</b></span><span>•</span>' +
            '<span>Üretim: <b>' + prodW + '×' + prodH + ' cm</b></span>' +
          '</div>' +
        '</div>'
      ) : '') +

      fabricBlock +

      '<div class="amorf-sms-confirm__disclaimer">' +
        'BU SİPARİŞ TAMAMEN KİŞİYE ÖZEL BİR ÜRETİMDİR.<br>FABRİKASYON HATASI DIŞINDA İADE ALINMAZ.' +
      '</div>' +

      '<div class="amorf-sms-confirm__cards">' +
        '<div class="amorf-sms-confirm__card">' +
          '<div class="amorf-sms-confirm__card-title">Kargo</div>' +
          '<div class="amorf-sms-confirm__card-value">ÜCRETSİZ</div>' +
        '</div>' +
        (kazanc ? (
          '<div class="amorf-sms-confirm__card amorf-sms-confirm__card--accent">' +
            '<div class="amorf-sms-confirm__card-title">Kazancınız</div>' +
            '<div class="amorf-sms-confirm__card-value">' + kazanc + '</div>' +
          '</div>'
        ) : (
          '<div class="amorf-sms-confirm__card amorf-sms-confirm__card--accent">' +
            '<div class="amorf-sms-confirm__card-title">Tahmini Teslim</div>' +
            '<div class="amorf-sms-confirm__card-value">3-5 iş günü</div>' +
          '</div>'
        )) +
      '</div>' +

      '<div class="amorf-sms-confirm__taksit">' +
        '<div class="amorf-sms-confirm__taksit-title">Ödeme Seçenekleri</div>' +
        '<div class="amorf-sms-confirm__taksit-row"><span>Peşin</span><b>' + totalPrice + '</b></div>' +
        '<div class="amorf-sms-confirm__taksit-row"><span>3 Taksit <em>(vade farksız)</em></span><b>' + taksit3 + ' / ay</b></div>' +
        '<div class="amorf-sms-confirm__taksit-row"><span>6 Taksit <em>(vade farksız)</em></span><b>' + taksit6 + ' / ay</b></div>' +
      '</div>' +

      '<label class="amorf-sms-confirm__checkbox">' +
        '<input type="checkbox" id="amorf-sms-confirm-chk">' +
        '<span>Siparişin kişiye özel üretim olduğunu, fabrikasyon hatası dışında iade alınmayacağını okudum ve onaylıyorum.</span>' +
      '</label>' +

      '<div class="amorf-sms-modal__error" id="amorf-sms-err"></div>'
    );
    // Sticky CTA — modalın altında sabit, scroll'dan bağımsız görünür
    modalEl.querySelector('.amorf-sms-modal').insertAdjacentHTML('beforeend',
      '<div class="amorf-sms-confirm__sticky-cta">' +
        '<button type="button" class="amorf-sms-modal__btn amorf-sms-confirm__cta" id="amorf-sms-proceed-btn" disabled>ÖDEMEYE DEVAM ET →</button>' +
      '</div>'
    );
    var chk = document.getElementById('amorf-sms-confirm-chk');
    var btn = document.getElementById('amorf-sms-proceed-btn');
    chk.addEventListener('change', function() { btn.disabled = !chk.checked; });
    btn.addEventListener('click', function() {
      if (!chk.checked) return;
      window.location.href = '/checkout';
    });
  }

  // ═══ GATE UI ═══
  function findCheckoutButtons() {
    var found = [];
    ADDED_SELECTORS_CHECKOUT.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (el.closest('[data-amorf-sms-gate]')) return; // bizim custom btn'imiz
        found.push(el);
      });
    });
    return found;
  }
  function lockCheckout() {
    findCheckoutButtons().forEach(function(btn) {
      btn.setAttribute('data-amorf-locked', '1');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.4';
      if (!btn._amorfClickHandler) {
        btn._amorfClickHandler = function(e) {
          if (btn.getAttribute('data-amorf-locked') === '1') {
            e.preventDefault(); e.stopPropagation();
            openGateModal();
          }
        };
        btn.addEventListener('click', btn._amorfClickHandler, true);
      }
    });
  }
  function unlockCheckout() {
    findCheckoutButtons().forEach(function(btn) {
      btn.removeAttribute('data-amorf-locked');
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    });
  }
  function openGateModal() { openModal(); renderStep1(); }

  // Banner UI
  function injectGateBanner(verified) {
    if (document.getElementById('amorf-sms-gate-banner')) return;
    var cart = document.querySelector('.hdt-page-cart, .cart, [class*=cart-wrap], main');
    if (!cart) return;
    var banner = document.createElement('div');
    banner.id = 'amorf-sms-gate-banner';
    banner.className = 'amorf-sms-gate-banner' + (verified ? ' is-verified' : '');
    var cnt = amorfItems.length;
    var desc = cnt > 1
      ? ('Sepetinizde ' + cnt + ' adet özel üretim halı var. Her biri için cep telefonunuza SMS ile tek seferlik onay gerekir.')
      : 'Sepetinizdeki özel üretim halı için cep telefonunuza SMS ile onay göndereceğiz.';
    banner.innerHTML =
      '<div class="amorf-sms-gate-banner__inner">' +
        '<div class="amorf-sms-gate-banner__icon">' + (verified ? '✓' : '!') + '</div>' +
        '<div class="amorf-sms-gate-banner__body">' +
          '<p class="amorf-sms-gate-banner__title">Kişiye Özel Üretim — SMS Onayı</p>' +
          '<p class="amorf-sms-gate-banner__desc">' + desc + '</p>' +
          '<p class="amorf-sms-gate-banner__status">✓ Onaylandı — ödemeye devam edebilirsiniz.</p>' +
        '</div>' +
      '</div>';
    // Başlık (main-heading section) üstüne çıkmasın: "Alışveriş Sepetiniz" başlığının hemen altına yerleştir.
    // cart.json sırası: heading (main-heading) → main-cart. Bu banner sadece amorf state'te görünür.
    var main = document.querySelector('main#MainContent, main') || document.body;
    var headingSection = main.querySelector('section.hdt-section-heading, .hdt-heading-template');
    if (headingSection && headingSection.parentNode) {
      headingSection.insertAdjacentElement('afterend', banner);
    } else {
      cart.prepend(banner);
    }
    if (!verified) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'amorf-sms-gate-btn';
      btn.setAttribute('data-amorf-sms-gate', '1');
      btn.innerHTML = 'SMS ile Onayla →';
      btn.addEventListener('click', openGateModal);
      banner.appendChild(btn);
    }
  }
  function updateGateUI(verified) {
    var banner = document.getElementById('amorf-sms-gate-banner');
    if (!banner) return;
    if (verified) {
      banner.classList.add('is-verified');
      var innerBtn = banner.querySelector('.amorf-sms-gate-btn');
      if (innerBtn) innerBtn.remove();
      unlockCheckout();
    } else {
      banner.classList.remove('is-verified');
    }
  }

  // ═══ INIT ═══
  async function init() {
    var hasAmorf = await loadCart();
    if (!hasAmorf) return; // normal sepet, dokunma

    // Her amorf previewId için ayrı doğrulama durumu
    var status = await apiStatus();
    var allVerified = status && status.ok && status.verified;

    injectGateBanner(allVerified);
    if (!allVerified) {
      lockCheckout();
      setTimeout(lockCheckout, 1000);
      setTimeout(lockCheckout, 3000);
    } else {
      unlockCheckout();
      verifiedData = { ad: status.ad };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
